import type { ChangeEventHandler, HTMLAttributes, HtmlHTMLAttributes, ReactNode } from 'react';

export interface AccordionLabelProps extends HTMLAttributes<HTMLLabelElement> {
  type?: 'store';
}
export interface AccordionTab {
  title: ReactNode;
  icon?: ReactNode;
  content?: ReactNode;
  defaultChecked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  labelProps?: AccordionLabelProps;
}

export interface AccordionData {
  tabs: AccordionTab[];
  maxLabelWidth?: boolean;
}

export interface AccordionProps extends HtmlHTMLAttributes<HTMLDivElement>, AccordionData {
  noScroll?: boolean;
  wrapperClass?: string;
  tabClass?: string;
  labelClass?: string;
}
